<template>
 <div class="common-flexbox flex-direction-column custom-container">
  <table class="custom-table">
    <thead>
      <tr>
        <th>Calling From</th>
        <th width="200">Number</th>
      </tr>
    </thead>
    <tbody v-for="(number, index) in globalNumbers" :key="index">
      <tr v-if="number.AutomatedTollPhoneNumbers.length">
        <td>{{number.Country.Name}}</td>
        <td class="numbers">
          <tr v-for="(tollNum, idx) in number.AutomatedTollPhoneNumbers" :key="idx">  
            {{telFormatter(tollNum, number.Country.Code)}}
          </tr>
        </td>
      </tr>
      <tr v-if="number.AutomatedPhoneNumbers.length">
        <td>{{number.Country.Name}} Toll-Free</td>
        <td class="numbers">
          <tr v-for="(tollfreeNum, idx) in number.AutomatedPhoneNumbers" :key="idx">
            {{telFormatter(tollfreeNum, number.Country.Code)}}
          </tr>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import Constants from "@/utils/constants";
import TelFormatter from "@/service/telFormatter";

// Import composables
import { useGlobal, useGlobalNumbers } from '@/composables/';

// Define component options
defineOptions({
  name: 'globalNumbers'
});

// Initialize composables
const { displaySystemMessage, setPageTitle } = useGlobal();
const { globalNumbers } = useGlobalNumbers();

// Methods
const telFormatter = (tel, countryCode, hideTelephoneCode) => {
  return TelFormatter(tel, countryCode, hideTelephoneCode);
};

// Lifecycle hooks
onBeforeMount(() => {
  setPageTitle(Constants.PageTitles.GlobalNumbers);
});
</script>

<style scoped lang="stylus">
@import '~@/shared/styles/common.scss';
.custom-table {
  width: 100%;
    text-align: left;
    line-height: 2;
    table-layout: fixed;
    th {
      color: #b7b7b7;
      line-height : 2;
      text-align: left;
    } 
    td {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    tr th:last-child,td:last-child { 
      padding-left : 20px; 
    }
}
.custom-container {
  width: 60%;
    box-sizing: border-box;
    height: auto;
    overflow-y: auto;
    border: none;
    box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.1);
    margin-top: 25px;
    margin-bottom: 15px;
    padding: 1% 2% 2% 2%;
    @media (max-width: 767px) {
      width: 100%;
    }
}
.label-color {
  color: #b7b7b7;
}
.gutter-space-between {
  width: 200px;
  text-align: left;
  line-height: 1.5;
}
.numbers {
  tr {
      border-bottom: none;
  }
  tr:not(:first-child) {
    display: block;
    margin-top: -5px;
  }
}

th,
td
  padding 5px;

tr
  border-bottom 1px solid #E6E6E6;
</style>
